import { Table } from 'antd';
import { billListSelectors } from 'containers/App/selectors';
import { getDataCPAPFromHospitalInMonth } from 'pages/ListBilling/thunk';
import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t_billing_process } from 'types';

type Props = {
  bill: t_billing_process;
  loadData: boolean;
};
const TableCpapAdd: FC<Props> = ({ bill, loadData }) => {
  const dispatch = useDispatch();
  const { detailCPAPFromHositalInMonth } = useSelector(billListSelectors);

  useEffect(() => {
    (async () => {
      if (loadData) {
        dispatch(
          getDataCPAPFromHospitalInMonth({
            invoice_id: bill.i_id || '',
            billing_type: 'o_recovery' || 'o_advance_payment',
            page: 1,
            per_page: 0,
          }),
        );
      }
    })();
  }, [dispatch, bill, loadData]);

  const columns: any = useMemo(() => {
    return [
      {
        title: 'No.',
        dataIndex: 'no',
        key: 'no',
        width: '5%',
        align: 'center',
        render(text: string, row: any, index: any) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{index + 1}</div>,
          };
        },
      },
      {
        title: 'ID',
        dataIndex: 'patient_id',
        key: 'patient_id',
        width: '10%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: 'ご利用者名',
        dataIndex: 'cpap_id',
        key: 'cpap_id',
        width: '15%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: 'CPAP請求月',
        key: 'target_month',
        dataIndex: 'target_month',
        width: '15%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { textAlign: 'left' },
              className: 'standardFont',
            },
            children: <div>{text ? `${text.slice(0, 4)}年${Number(text.slice(4))}月` : ''}</div>,
          };
        },
      },
      {
        title: '備考',
        key: 'hospital_visit_remark',
        dataIndex: 'hospital_visit_remark',
        width: '40%',
        align: 'center',
        render(text: string) {
          return {
            props: {
              style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', paddingLeft: '10px' },
              className: 'standardFont',
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];
  }, []);

  return (
    <div>
      <Table
        onRow={() => {
          return {
            // onClick: () => {
            //   moveTo();
            // },
          };
        }}
        columns={columns}
        dataSource={detailCPAPFromHositalInMonth}
        pagination={false}
      />
    </div>
  );
};

export default TableCpapAdd;
